module.exports = {"result":"Search Result","group":"Group ID","transaction":"Transaction ID","invoice":"Invoice","profit":"Profit","debt":"Debt","baseFare":"Base","credit":"Credit","sellPrice":"Sell","ticketedTime":"Ticketed Time","startDate":"Start Date","endDate":"End Date","clear":"CLEAR","finish":"FINISH","lock":"LOCK","paid":"PAID","payment_lock":"Pay Lock","salesName":"Sales","statement":"Statement"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/accounting/management/result.json
// module id = OtVY
// module chunks = 58